import { Stack } from 'libs/ui';

import { OperationFormContentProvider } from '../../providers/OperationFormContentProvider';
import { OperationMode } from '../../types';
import {
  AdditionalNotesSection,
  ClientsOrderSection,
  DocumentsSection,
  FinancialInstrumentSection,
  MainInformationSection,
  ParametorsSection,
  SettlementSection,
} from '../sections';

export interface OperationFormContentProps {
  mode: OperationMode;
  canChangeClientAndOrder?: boolean;
  brokerTimezoneOffset: number;
  operationId?: string;
  createdAt?: Date;
}

export const OperationFormContent = ({
  brokerTimezoneOffset,
  operationId,
  createdAt,
  mode,
  canChangeClientAndOrder = true,
}: OperationFormContentProps) => (
  <OperationFormContentProvider
    brokerTimezoneOffset={brokerTimezoneOffset}
    canChangeClientAndOrder={canChangeClientAndOrder}
    createdAt={createdAt}
    mode={mode}
    operationId={operationId}
  >
    <Stack spacing={24}>
      <ClientsOrderSection />
      <MainInformationSection />
      <FinancialInstrumentSection />
      <ParametorsSection />
      <SettlementSection />
      <DocumentsSection />
      <AdditionalNotesSection />
    </Stack>
  </OperationFormContentProvider>
);
